/// <reference types="./EntityCollectors.d.ts" />
import { ContentTraverseNodeType, isComponentItemField, isLocationItemField, isReferenceItemField, isRichTextComponentNode, isRichTextEntityLinkNode, isRichTextEntityNode, isRichTextTextNode, isStringItemField, } from '@dossierhq/core';
import { assertIsDefined } from './utils/AssertUtils.js';
export function createFullTextSearchCollector() {
    const fullTextSearchText = [];
    return {
        collect: (node) => {
            switch (node.type) {
                case ContentTraverseNodeType.fieldItem:
                    if (isStringItemField(node.fieldSpec, node.value) && node.value) {
                        fullTextSearchText.push(node.value);
                    }
                    break;
                case ContentTraverseNodeType.richTextNode: {
                    const richTextNode = node.node;
                    if (isRichTextTextNode(richTextNode) && richTextNode.text) {
                        fullTextSearchText.push(richTextNode.text);
                    }
                    break;
                }
            }
        },
        get result() {
            return fullTextSearchText.join(' ');
        },
    };
}
//TODO we have three similar implementations of this function, should it move to core?
export function createReferencesCollector() {
    const references = new Set();
    return {
        collect: (node) => {
            switch (node.type) {
                case ContentTraverseNodeType.fieldItem:
                    if (isReferenceItemField(node.fieldSpec, node.value) && node.value) {
                        references.add(node.value.id);
                    }
                    break;
                case ContentTraverseNodeType.richTextNode: {
                    const richTextNode = node.node;
                    if (isRichTextEntityNode(richTextNode) || isRichTextEntityLinkNode(richTextNode)) {
                        references.add(richTextNode.reference.id);
                    }
                    break;
                }
            }
        },
        get result() {
            return [...references].map((id) => ({ id }));
        },
    };
}
export function createRequestedReferencesCollector() {
    const requestedReferences = [];
    return {
        collect: (node) => {
            switch (node.type) {
                case ContentTraverseNodeType.fieldItem:
                    if (isReferenceItemField(node.fieldSpec, node.value) && node.value) {
                        const entityItemFieldSpec = node.fieldSpec;
                        requestedReferences.push({
                            path: node.path,
                            uuids: [node.value.id],
                            entityTypes: entityItemFieldSpec.entityTypes,
                            linkEntityTypes: undefined,
                            isRichTextLink: false,
                        });
                    }
                    break;
                case ContentTraverseNodeType.richTextNode: {
                    const richTextNode = node.node;
                    if (isRichTextEntityNode(richTextNode) || isRichTextEntityLinkNode(richTextNode)) {
                        const richTextFieldSpecification = node.fieldSpec;
                        requestedReferences.push({
                            path: node.path,
                            uuids: [richTextNode.reference.id],
                            entityTypes: richTextFieldSpecification.entityTypes,
                            linkEntityTypes: richTextFieldSpecification.linkEntityTypes,
                            isRichTextLink: isRichTextEntityLinkNode(richTextNode),
                        });
                    }
                    break;
                }
            }
        },
        get result() {
            return requestedReferences;
        },
    };
}
export function createUniqueIndexCollector(schema) {
    const uniqueIndexValues = new Map();
    return {
        collect: (node) => {
            switch (node.type) {
                case ContentTraverseNodeType.fieldItem: {
                    const indexName = 'index' in node.fieldSpec ? node.fieldSpec.index : undefined;
                    if (indexName && isStringItemField(node.fieldSpec, node.value) && node.value) {
                        const indexValues = uniqueIndexValues.get(indexName);
                        if (indexValues) {
                            //TODO fail on duplicates?
                            if (!indexValues.find((it) => it.value === node.value)) {
                                indexValues.push({ path: node.path, value: node.value });
                            }
                        }
                        else {
                            const index = schema.getIndex(indexName);
                            assertIsDefined(index);
                            if (index.type === 'unique') {
                                uniqueIndexValues.set(indexName, [{ path: node.path, value: node.value }]);
                            }
                        }
                    }
                    break;
                }
            }
        },
        get result() {
            return uniqueIndexValues;
        },
    };
}
export function createLocationsCollector() {
    const locations = [];
    return {
        collect: (node) => {
            switch (node.type) {
                case ContentTraverseNodeType.fieldItem:
                    if (isLocationItemField(node.fieldSpec, node.value) && node.value) {
                        locations.push(node.value);
                    }
                    break;
            }
        },
        get result() {
            return locations;
        },
    };
}
export function createComponentTypesCollector() {
    const payload = new Set();
    return {
        collect: (node) => {
            switch (node.type) {
                case ContentTraverseNodeType.fieldItem:
                    if (isComponentItemField(node.fieldSpec, node.value) && node.value) {
                        payload.add(node.value.type);
                    }
                    break;
                case ContentTraverseNodeType.richTextNode: {
                    const richTextNode = node.node;
                    if (isRichTextComponentNode(richTextNode)) {
                        payload.add(richTextNode.data.type);
                    }
                    break;
                }
            }
        },
        get result() {
            return [...payload];
        },
    };
}
//# sourceMappingURL=EntityCollectors.js.map